<template>
  <base-query class="aisevent">
    <el-form
      slot="searchBox"
      size="mini"
      label-position="right"
      label-width="100px"
    >
      <div class="contentLeft">
        <el-row>
          <el-col style="width: 22%">
            <el-form-item label="单号">
              <el-input
                v-model="form.bill"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="箱号">
              <el-input
                v-model="form.ctnr"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="查询时间">
              <el-select
                slot="label"
                v-model="form.timeType"
                size="small"
                class="search-time-select"
              >
                <el-option
                  v-for="type in timeTypes"
                  :key="type.code"
                  :value="type.code"
                  :label="type.name"
                />
              </el-select>
              <el-date-picker
                v-model="form.btm"
                clearable
                type="datetime"
                style="width: 100%"
                placeholder="开始日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="——">
              <el-date-picker
                v-model="form.etm"
                clearable
                style="width: 100%"
                type="datetime"
                placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col style="width: 22%">
            <el-form-item label="船公司">
              <el-input
                v-model="form.carrier"
                style="width: 100%"
                clearable
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="MMSI">
              <el-input
                v-model="form.mmsi"
                style="width: 100%"
                clearable
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="五字码">
              <el-input
                v-model="form.code"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="船名">
              <el-input
                v-model="form.vessel"
                clearable
                style="width: 100%"
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col style="width: 22%">
            <el-form-item label="用户名">
              <el-input
                v-model="form.uname"
                style="width: 100%"
                clearable
                placeholder="请输入"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col style="width: 22%">
            <el-form-item label="MMSI">
              <el-input style="width: 100%" v-model="form.mmsi" clearable placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="五字码">
              <el-input v-model="form.code" clearable style="width: 100%" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col style="width: 22%">
            <el-form-item label="船名">
              <el-input v-model="form.vessel" clearable style="width: 100%" placeholder="请输入" />
            </el-form-item>
          </el-col> -->
        </el-row>
      </div>
      <div class="contenRight">
        <el-checkbox
          v-model="form.queryNoData"
          style="margin-right: 10px"
          @change="listSubscription(1)"
        >
          无数据
        </el-checkbox>
        <el-button
          size="small"
          class="serachBtn"
          :loading="isloading"
          @click="exportSubscription"
        >
          导出
        </el-button>
        <el-button
          size="small"
          class="serachBtn"
          :loading="isloading"
          @click="listSubscription(1)"
        >
          搜索
        </el-button>
      </div>
      <div style="clear: both"></div>
    </el-form>

    <!-- <div style="text-align: right; margin: 0 0 5px 0">
      <el-button size="mini" type="text" @click="historyVoyageF = true">历史挂靠</el-button>
    </div> -->

    <el-table
      ref="table"
      v-loading="isloading"
      :data="subscriptionlist"
      size="mini"
      height="550"
      max-height="550"
      row-key="id"
      :row-class-name="handleRowClass"
      :cell-class-name="handleCellClass"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="uname" label="用户名" width="150" />
      <el-table-column prop="bill" label="单号" width="150" />

      <el-table-column prop="ctnr" label="箱号" width="150" />

      <el-table-column prop="carrier" label="船公司" width="80" />

      <el-table-column prop="mmsi" label="MMSI" width="100" />

      <el-table-column
        prop="vessel"
        label="船名"
        width="130"
        show-overflow-tooltip
      />

      <el-table-column prop="code" label="五字码" width="100" />

      <el-table-column
        prop="routeSort"
        label="港口顺序"
        width="100"
        align="right"
      />

      <el-table-column
        prop="name"
        label="港口中文名"
        width="130"
        show-overflow-tooltip
      />

      <el-table-column
        prop="nameEn"
        label="港口英文名"
        width="130"
        show-overflow-tooltip
      />

      <el-table-column prop="timezone" label="时区" width="80" align="center" />

      <el-table-column prop="btm" label="开始时间" width="150" />

      <el-table-column prop="etm" label="结束时间" width="150" />

      <el-table-column prop="ata" label="ATA" width="150" />

      <el-table-column prop="atbA" label="ATB_A" width="150" />

      <el-table-column prop="atbD" label="ATB_D" width="150" />

      <el-table-column prop="atd" label="ATD" width="150" />

      <el-table-column label="船舶计划" align="center">
        <el-table-column prop="setd" label="ETD" min-width="150" />

        <el-table-column prop="seta" label="ETA" min-width="150" />

        <el-table-column prop="sata" label="ATA" min-width="150" />

        <el-table-column prop="satd" label="ATD" min-width="150" />
      </el-table-column>

      <el-table-column
        prop="loading"
        label="装船"
        min-width="180"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.loading }}</span>
          <span
            v-if="scope.row.loadingCode"
            style="color: #888; margin-left: 3px"
            >({{ scope.row.loadingCode }})</span
          >
        </template>
      </el-table-column>

      <el-table-column
        prop="unloading"
        label="卸船"
        min-width="180"
        align="center"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.unloading }}</span>
          <span
            v-if="scope.row.unloadingCode"
            style="color: #888; margin-left: 3px"
          >
            ({{ scope.row.unloadingCode }})
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间" width="150" />

      <el-table-column prop="updateTime" label="更新时间" width="150" />

      <el-table-column
        prop="updateCount"
        label="更新次数"
        width="80"
        align="right"
      >
        <span slot-scope="scope" style="font-weight: bold">
          {{ scope.row.updateCount }}
        </span>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="160" align="center">
        <div slot-scope="scope" style="width: 100%; text-align: center">
          <el-button
            type="text"
            size="mini"
            :loading="scope.row._loading"
            @click="forceUpdate(scope.row)"
          >
            更新
          </el-button>
          <el-button type="text" size="mini" @click="looksub(scope.row)">
            查看
          </el-button>
        </div>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="total,prev,pager,next"
      :total="total"
      :page-size="50"
      :current-page.sync="num"
      class="pagination"
      @current-change="listSubscription"
    />

    <el-dialog
      :visible.sync="looksubing"
      append-to-body
      width="50%"
      @close="closeDialog"
    >
      <ais-event-look-dialog
        :info="lookrow"
        @saveSuccessful="saveSuccessful"
        @close="closeDialog"
        @trace-sequence="onGetTraceSequence"
      />
    </el-dialog>

    <el-dialog :visible.sync="traceSequenceWin.show" append-to-body width="50%">
      <trace-sequence-win
        :sequence="traceSequenceWin.sequence"
        :active.sync="traceSequenceWin.active"
      />
    </el-dialog>
  </base-query>
</template>

<script>
import BaseQuery from '@/components/BaseQuery.vue'
import AisEventLookDialog from './AisEventLookDialog.vue'
import request from '@/mixins/request'
import TraceSequenceWin from './TraceSequenceWin.vue'

const sleep = async ms => new Promise(resolve => setTimeout(resolve, ms))

export default {
  components: {
    BaseQuery,
    AisEventLookDialog,
    TraceSequenceWin,
  },

  mixins: [request],

  // filters: {
  //     placeTypeConv(type) {
  //         if (type === 1) {
  //             return '接货地';
  //         }

  //         if (type === 2) {
  //             return '起始港';
  //         }

  //         if (type === 3) {
  //             return '中转港';
  //         }

  //         if (type === 4) {
  //             return '目的港';
  //         }

  //         if (type === 5) {
  //             return '交货地';
  //         }

  //         return '未知';
  //     }
  // },

  data() {
    return {
      subscriptionlist: [],

      form: {
        bill: '',
        ctnr: '',
        btm: '',
        etm: '',
        carrier: '',
        mmsi: '',
        code: '',
        vessel: '',
        uname: '',
        timeType: 'start',
        queryNoData: false,
      },

      num: 1,

      total: 0,

      isloading: false,

      looksubing: false,

      lookrow: {},

      traceSequenceWin: {
        show: false,
        sequence: {},
        active: 0,
      },
    }
  },

  computed: {
    conditional() {
      for (const k in this.form) {
        if (this.form[k]) {
          return true
        }
      }
    },

    timeTypes() {
      return [
        {
          code: 'update',
          name: '更新时间',
        },
        {
          code: 'create',
          name: '创建时间',
        },
        {
          code: 'end',
          name: '结束时间',
        },
        {
          code: 'start',
          name: '开始时间',
        },
      ]
    },
  },

  mounted() {
//    this.listSubscription()
//    this.$on('activate', this.listSubscription)
  },

  methods: {
    onGetTraceSequence(traceSequence) {
      console.log(traceSequence)
      this.traceSequenceWin.sequence = traceSequence || {}
      this.traceSequenceWin.active = 0
      this.traceSequenceWin.show = true
    },

    async saveSuccessful() {
      this.closeDialog()
      this.isloading = true
      try {
        await sleep(2000)
        if (this.conditional) {
          await this.listSubscription(this.num)
        } else {
          await this.refreshcurrent()
        }
      } finally {
        this.isloading = false
      }
    },

    async listSubscription(num) {
      this.isloading = true

      try {
        const resp = await this.$api.post(
          '/trace/aiseventops/listSubscription',
          this.form,
          {
            params: {
              num: num || 1,
            },

            baseURL: '/',
          }
        )

        if (resp.data.status === 1) {
          const data = resp.data.content.list || []

          data.forEach(item => {
            if (item.mmsi === 0) {
              item.mmsi = ''
            }
          })

          this.subscriptionlist = data
          this.total = resp.data.content.total
          this.num = resp.data.content.pageNum
        } else {
          return this.$message.error(resp.data.message || '获取订阅列表错误')
        }
      } finally {
        this.isloading = false
      }
    },

    async refreshcurrent() {
      const ids = (this.subscriptionlist || []).map(k => k.id)

      if (!ids.length) {
        return
      }

      this.isloading = true
      try {
        const resp = await this.$api.post('/trace/aiseventops/refresh', ids, {
          baseURL: '/',
        })

        if (resp.data.status === 1) {
          ;(resp.data.content || []).forEach(item => {
            const index = this.subscriptionlist.findIndex(k => k.id === item.id)

            if (index !== -1) {
              if (item.mmsi === 0) {
                item.mmsi = ''
              }
              this.subscriptionlist.splice(index, 1, item)
            }
          })
        }
      } finally {
        this.isloading = false
      }
    },

    looksub(row) {
      this.looksubing = true
      this.lookrow = row

      const table = this.$refs.table

      if (table) {
        table.toggleRowSelection(row, true)
      }
    },

    async forceUpdate(row) {
      const id = row.id

      try {
        this.$set(row, '_loading', true)

        const resp = await this.$api.get('/trace/aiseventops/forceUpdate', {
          params: {
            id,
            updateCount: row.updateCount,
          },

          baseURL: '/',
        })

        if (resp.data.status === 1) {
          let f = resp.data.content
          if (typeof f === 'number') {
            if (f & 1) {
              this.$message.success('有变动，已推入更新队列')
              await sleep(2000)
            } else {
              this.$message.warning('无变动，无需更新')
            }
          }

          if (this.conditional) {
            await this.listSubscription(this.num)
          } else {
            await this.refreshcurrent()
          }
        } else {
          this.$message.error(resp.data.message || '更新错误')
        }
      } finally {
        this.$set(row, '_loading', false)
      }
    },

    closeDialog() {
      this.looksubing = false
      this.lookrow = {}
    },

    handleRowClass(scope) {
      const row = scope.row

      return (
        'is-gettime_' +
        [row.ata, row.atd, row.atbA, row.atbD].reduce(
          (prev, curr) => prev + (curr ? 1 : 0),
          0
        )
      )
    },

    handleCellClass(scope) {
      const property = scope.column.property,
        requiredField = scope.row.requiredField

      if (requiredField === 1 && (property === 'ata' || property === 'atbA')) {
        return 'highcell-' + property
      }

      if (requiredField === 2 && (property === 'atd' || property === 'atbD')) {
        return 'highcell-' + property
      }
    },

    async exportSubscription() {
      this.isloading = true
      try {
        const resp = await this.$api.post(
          '/trace/aiseventops/listSubscription/export',
          this.form,
          {
            baseURL: '/',
            responseType: 'blob',
          }
        )

        let url = window.URL.createObjectURL(resp.data)
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        console.log(resp)
        let contentDisposition = resp.headers['content-disposition']
        console.log('contentDisposition = ' + contentDisposition)
        if (contentDisposition) {
          let fileName = contentDisposition.split('filename=')
          link.setAttribute('download', fileName[1])
          document.body.appendChild(link)
          link.click()
        } else {
          this.$message.error('暂无数据')
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.isloading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.aisevent {
  padding: 0;

  .search-time-select {
    ::v-deep .el-input {
      > input {
        border: none;
        padding-right: 0 !important;
        text-align: right;
      }

      > .el-input__suffix {
        display: none;
      }
    }
  }

  .pagination {
    text-align: right;
    padding: 10px 0;
  }

  .serachBtn {
    padding: 9px 35px;
    color: #fff;
    background-color: #0499ff;
    border: 1px solid #3bafda;
  }

  .contentLeft {
    // float: left;
    width: 90%;
    padding: 20px 20px 0px 20px;
  }

  .contenRight {
    // position: absolute;
    // right: 20px;
    // bottom: 5px;
    text-align: right;
  }

  ::v-deep .el-row .el-col:nth-last-of-type(1) {
    margin-right: 0;
  }

  ::v-deep .el-col {
    margin-right: 20px;
  }

  label:nth-of-type(2) {
    width: 10px !important;
  }

  ::v-deep .highcell {
    &-ata,
    &-atbD {
      border-bottom: 2px #851f1f solid;
    }

    &-atd,
    &-atbA {
      border-bottom: 2px #851f1f solid;
    }
  }

  ::v-deep .is-gettime_0 {
    & > td:first-child {
      border-left: 2px solid #e6a23c;
    }
  }

  .buttonTop {
    margin-bottom: 20px;

    .clickColor {
      background-color: #fff;
      padding: 9px 15px;
      margin-right: 10px;
    }

    .teshunormal {
      color: #3bafda;
      border: 1px solid #3bafda;
      width: 80px;
      cursor: pointer;
      background: #fff;
      text-align: center;
      margin-right: 20px;
    }
  }
}
</style>
